import { render, staticRenderFns } from "./LogoOpCharge.vue?vue&type=template&id=780547d6"
var script = {}
import style0 from "./LogoOpCharge.vue?vue&type=style&index=0&id=780547d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports